import store from '@/state/store'

const hasAccessAll = store.getters['identity/hasAccessAll']
const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read'])

const getDOListFields = (self) =>
  [
    {
      label: self.$t('routeOptimization.fields.deliveryNumber'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
    },
    {
      label: self.$t('routeOptimization.fields.status'),
      key: 'status.name',
    },
    {
      label: self.$t('routeOptimization.fields.originAddress'),
      key: 'origin_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.destinationAddress'),
      key: 'destination_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.shipmentNumber'),
      key: 'shipment_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.referenceNumber'),
      key: 'reference_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.createdOn'),
      key: 'created_on',
      isSortable: true,
    },
    {
      label: self.$t('routeOptimization.fields.createdBy'),
      key: 'created_by',
      isSortable: true,
    },
    {
      label: self.$t('global.field.userGroup'),
      key: 'user_group.name',
      isSortable: true,
      isShow: hasTmsUserGroupAccess,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.shippedCustomerName'),
      key: 'shipped_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.billedCustomerName'),
      key: 'billed_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.marketingStaff'),
      key: 'marketing_user.name',
      isSortable: true,
      isEllipsis: true,
    },
  ].filter((field) => field?.isShow !== false)

export default getDOListFields
